export default __webpack_public_path__ + "static/documentation-graphic-tilted-cb680894ba9b547a8d0c2a08ec15dfdd.svg";